/* Copyright(c) 2019 APSS Media Pvt. Ltd.
*  All Rights Reserved
*/

/*@author Sanjana Godbole
*@fileName :
 *Desc: Agency Bank details tab
*/

import React from 'react';
import 'antd/dist/antd.css';
import { Form,Input, Button,Tooltip,Icon } from 'antd';
import Footer from "../layouts/footer";
import { bake_cookie, read_cookie, delete_cookie } from 'sfcookies';
const cookie_key = 'agencyID';
const Swal = require('sweetalert2');
class AgencyBankDetails extends React.Component {
  state = { newsuccess:'',
  infoMsg:'',
  buttonDisplay:'disabled',
  displayBankName:'disabled',
  displayAccountNumber:'disabled',
  displayAccountHolder:'disabled',
  displayIFSCCode:'disabled',
  displayPAN:'disabled',
  displayGST:'disabled',
};




  componentDidMount()
  {
   // var agencyID=localStorage.getItem('agencyID');
   // alert("PublisherId from Local storage====>"+agencyID);
   var agencyID= read_cookie(cookie_key);
    if(agencyID=="")
    {
      this.setState({
        buttonDisplay: 'disabled',
        displayBankName:'disabled',
        displayAccountNumber:'disabled',
        displayAccountHolder:'disabled',
        displayIFSCCode:'disabled',
        displayPAN:'disabled',
        displayGST:'disabled',
        infoMsg:'Please Fill Company Information First'
      });
    }
    else
    {
      this.setState({
        buttonDisplay: "button",
        displayBankName:'',
        displayAccountNumber:'',
        displayAccountHolder:'',
        displayIFSCCode:'',
        displayPAN:'',
        displayGST:'',
        infoMsg:''
      });
    }
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => 
    {
      if (!err) {
        // alert('Received values of form: '+ JSON.stringify(values));
        // console.log('Received values of form: ', values);
        // alert(JSON.stringify(values));
        //var agencyID=localStorage.getItem('agencyID');
        var agencyID= read_cookie(cookie_key)
        // alert(agencyID);
        let data={
          userID:agencyID,
          bankName:values.bankName,
          accountNumber:values.accountNumber,
          accountHolderName:values.accountholderName,
          ifscCode:values.ifscCode,
          panNumber:values.panNumber,
          gstNumber:values.taxNumber          
        }
         //alert("DAta :"+JSON.stringify(data));
        fetch("/publisherOnBoardDetails/bankInformation", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data)
        }).then(res=>res.json()).then(res=>{
          // alert(JSON.stringify(res))
          console.warn("Response in res in=="+JSON.stringify(res));
            if(res.success==true)
            {
              var a=(res.message);
              // alert(a)
              Swal.fire({
                type:'success',
                title:'Bank information saved successfully !',
              })
              // this.setState({newsuccess:a});
              this.setState({
                buttonDisplay:'disabled'});
             }
             delete_cookie('agencyID');
        }).catch(function (err) {
          console.log(err)
        });
      }
      else
      {
        //  alert("Please fill the form");
      }
    });
  };

 



  handleChange=e => {

    let fields = this.state;
    fields[e.target.name] = e.target.value;
    this.setState({
      fields
    });
   // alert("Value====>"+this.state.companyName);
    
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };
  

  

    return (
      <div>
      
      <div class="container-fluid">
      <br/><br/>
      <div style={{ fontSize: '22px', color: 'green',paddingLeft:'490px'}}>{this.state.newsuccess}</div>
      <div style={{ fontSize: '16px', color: '#1890ff',paddingLeft:'490px'}}>{this.state.infoMsg}</div>
          <br/>

  <Form {...formItemLayout} onSubmit={this.handleSubmit}>
<div class="row">

<div class="col-xs-12  col-sm-12 col-md-6 col-lg-6">  
  <Form.Item
          label={
            <span>
            Bank Name&nbsp;
              {/* <Tooltip title="As per registration">
                <Icon type="question-circle-o" />
              </Tooltip> */}
            </span>
          }
        >
          {getFieldDecorator('bankName', {
            rules: [{ pattern:/^[A-Za-z\s]+$/,required: true, message: 'Please input your bank name!', whitespace: true }],
          })(<Input  onChange={this.handleChange} id="bankName" name="bankName"  disabled={this.state.displayBankName}/>)}
        </Form.Item>
       
        </div>
 
        <div class="col-xs-12  col-sm-12 col-md-6 col-lg-6">  
        <Form.Item
          label={
            <span>
            Account Number&nbsp;
              {/* <Tooltip title="As per registration">
                <Icon type="question-circle-o" />
              </Tooltip> */}
            </span>
          }
        >
          {getFieldDecorator('accountNumber', {
            rules: [{ pattern:/^[0-9]*$/, required: true, message: 'Please input your valid account number!', whitespace: true }],
          })(<Input  onChange={this.handleChange} id="accountNumber" name="accountNumber" disabled={this.state.displayAccountNumber}/>)}
        </Form.Item>
        </div>
 </div>  
 {/* End of 1st Row */}

 <div class="row">

<div class="col-xs-12  col-sm-12 col-md-6 col-lg-6">  
<Form.Item
          label={
            <span>
            Accountholder Name&nbsp;
              {/* <Tooltip title="As per registration">
                <Icon type="question-circle-o" />
              </Tooltip> */}
            </span>
          }
        >
          {getFieldDecorator('accountholderName', {
            rules: [{ pattern:/^[A-Za-z\s]+$/,required: true, message: 'Please input your accountholder name!', whitespace: true }],
          })(<Input  onChange={this.handleChange} id="accountholderName" name="accountholderName" disabled={this.state.displayAccountHolder}/>)}
        </Form.Item>
       
        </div>
        <div class="col-xs-12  col-sm-12 col-md-6 col-lg-6">  
<Form.Item
          label={
            <span>
            IFSC Code&nbsp;
              <Tooltip title="Example -BKID0000660">
                <Icon type="question-circle-o" />
              </Tooltip>
            </span>
          }
        >
          {getFieldDecorator('ifscCode', {
            rules: [{ pattern:/^[A-Za-z]{4}[a-zA-Z0-9]{7}$/,required: true, message: 'Please input your IFSC Code!', whitespace: true }],
          })(<Input  onChange={this.handleChange} id="ifscCode" name="ifscCode" disabled={this.state.displayIFSCCode}/>)}
        </Form.Item>
       
        </div>
 
       
 </div>
{/* End of 2nd Row */}


 <div class="row">

<div class="col-xs-12  col-sm-12 col-md-6 col-lg-6">  
<Form.Item label={<span>PAN/TAN Number&nbsp;
  <Tooltip title="Example:PAN:AAAPL1234C&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  &nbsp;&nbsp;TAN: RXOY 02811 K">
          <Icon type="question-circle-o" />
  </Tooltip>

</span>
}>
          {getFieldDecorator('panNumber', {
             rules: [{pattern:/[A-Za-z]{5}\d{4}[A-Za-z]{1}/, required: true, message: 'Please input your PAN/TAN Number!' }],
          })(<Input style={{ width: '100%' }} onChange={this.handleChange} id="panNumber" name="panNumber" disabled={this.state.displayPAN} />)}
        </Form.Item>
       
        </div>
 
        <div class="col-xs-12  col-sm-12 col-md-6 col-lg-6">  
       
        <Form.Item label={<span>TAX/GST Number&nbsp;
        <Tooltip title="Example- TAX :XXX-XX-XXXX   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; GST: 22 AAAAA0000A 1 Z 5">
                  <Icon type="question-circle-o" />
       </Tooltip>
       </span>
        }
        >
          {getFieldDecorator('taxNumber', {
            rules: [{pattern:/^([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-7]{1})([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$/, required: true, message: 'Please input TAX/GST Number!' }],
          })(<Input onChange={this.handleChange} id="taxNumber" name="taxNumber" disabled={this.state.displayGST} />)}
        </Form.Item>
        </div>
 </div> 
{/* End of 3rd Row       */}
       

      
<div class="row">
        <div class="col-xs-12  col-sm-12 col-md-6 col-lg-6">  
        </div>
        <div class="col-xs-12  col-sm-12 col-md-6 col-lg-6">
          <Form.Item {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit" className={this.state.buttonDisplay}>
            Save 
          </Button>
        </Form.Item> 
          </div>
        </div>

        {/* End of 4th row */}


        
      </Form>


  
</div>
<Footer/>
</div> 



// Final Div
     
    );
  }
}
const agencyRegistrationForm4 = Form.create({ name: 'register' })(AgencyBankDetails);

export default agencyRegistrationForm4;

          